/**
 * 导航服务组件
 */

import { useState } from 'react';
import {
    BellOutlined,
    SkinOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
} from '@ant-design/icons';
import {
    Badge,
    Button,
    Space,
} from 'antd';
import CNF from '../incs/Config';

const XNavService = (props) => {
    const [themeNum, setThemeNum] = useState(0);
    return <Space>
        <Badge
            count={props.msgCount ? props.msgCoun : 0}
            overflowCount={10}
            offset={[0, 5]}
        >
            <Button title='消息' style={{ padding: '0 5px' }} color='primary' variant='link' icon={<BellOutlined />}></Button>
        </Badge>
        <Button title='紧凑的' style={{ padding: '0 5px' }} color='primary' variant='link' onClick={() => {
            // 是否紧凑
            props.setIsCompact(!props.isCompact);
        }} >{
                props.isCompact ? <FullscreenOutlined /> : <FullscreenExitOutlined />
            }
        </Button>
        <Button title='主题皮肤' style={{ padding: '0 5px' }} color='primary' variant='link' onClick={() => {
            // 切换皮肤
            let num = themeNum >= CNF.themeColors.length - 1 ? 0 : themeNum + 1;
            setThemeNum(num);
            global.THEMECOLOR = CNF.themeColors[num];
            props.setThemeColor(CNF.themeColors[num]);
        }} ><SkinOutlined />
        </Button>
    </Space >
}

export default XNavService;